import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GateWayService } from '../../services/gateway-service.service';
@Component({
  selector: 'app-platform-logout',
  templateUrl: './platform-logout.component.html',
  styleUrls: ['./platform-logout.component.scss']
})
export class PlatformLogoutComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private gwService: GateWayService,) { }

  ngOnInit() {
  
    this.logout();
  }
  async logout() {
    this.gwService.ADMDLogout()
      .subscribe(async () => {
        let state = localStorage.getItem('state')        
        localStorage.clear();
        await this.gwService.getADMDLoginURI(state).subscribe(success => {
          if(success.code == 200) window.location.href = success.data.url
        });
      });
  }
}
